import { useState } from "react";
import { Forward } from "components/common/Icons";
import { TYPO } from "styles/Typo";
import StrategyInfoModal from "components/modals/StrategyInfoModal";
import { STRATEGY_META, STRATEGY_TYPE } from "utils/constant/STATUS";

function StrategyInfo({ risk, sCode }: { risk: number; sCode: STRATEGY_TYPE }) {
  const [openModal, setOpenModal] = useState<"risk" | "recommand" | false>(
    false
  );
  return (
    <div>
      <div className="px-6 pt-6">
        <p className={`${TYPO.TYPO5_1_SB} text-gray80`}>전략 정보</p>
      </div>
      <div className="p-4 w-full grid grid-cols-2 gap-2">
        <div className="flex flex-col p-1 flex-1">
          <p className={`${TYPO.TYPO7_1_RG} text-gray50`}>시장</p>
          <p className={`${TYPO.TYPO5_1_MD} text-gray80`}>
            {STRATEGY_META[sCode].country}
          </p>
        </div>
        <div
          className="flex p-1 cursor-pointer hover:bg-gray2 rounded-[8px] flex-1 items-center justify-between"
          onClick={() => {
            setOpenModal("risk");
          }}
          data-gtm-id="stInfoRisk"
        >
          <div className="flex flex-col">
            <p className={`${TYPO.TYPO7_1_RG} text-gray50`}>하락 리스크</p>
            <p
              className={`${TYPO.TYPO5_1_MD} text-gray80`}
            >{`최대 -${risk}%`}</p>
          </div>
          <Forward fill="gray40" height={16} width={16} />
        </div>
        <div className="flex flex-col p-1 flex-1">
          <p className={`${TYPO.TYPO7_1_RG} text-gray50`}>종목 교체 주기</p>
          <p className={`${TYPO.TYPO5_1_MD} text-gray80`}>1개월</p>
        </div>
        <div
          className="flex p-1 cursor-pointer hover:bg-gray2 rounded-[8px] flex-1 items-center justify-between"
          onClick={() => {
            setOpenModal("recommand");
          }}
          data-gtm-id="stInfoWeight"
        >
          <div className="flex flex-col">
            <p className={`${TYPO.TYPO7_1_RG} text-gray50`}>추천성향</p>
            <p className={`${TYPO.TYPO5_1_MD} text-gray80`}>
              {STRATEGY_META[sCode].recommandType}
            </p>
          </div>
          <Forward fill="gray40" height={16} width={16} />
        </div>
      </div>
      {openModal && (
        <StrategyInfoModal
          setModalOpen={setOpenModal}
          isModalOpen={openModal}
          sCode={sCode}
        />
      )}
    </div>
  );
}

export default StrategyInfo;
